import PropTypes from "prop-types";
import styled from "styled-components";

import { Placeholder } from "components/Placeholder";

const ATPChartPlaceholderContainer = styled.div`
  .custom-placeholder {
    min-height: ${({ height }) => height};
  }
`;

const AverageTradePerformanceChartPlaceholder = ({ height }) => {
  return (
    <ATPChartPlaceholderContainer height={height}>
      <Placeholder className="custom-placeholder" />
    </ATPChartPlaceholderContainer>
  );
};

AverageTradePerformanceChartPlaceholder.propTypes = {
  height: PropTypes.string,
};

export { AverageTradePerformanceChartPlaceholder };
